import * as Common from "../../commons/common"

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  exec_date: string
  grade: number
  kind: number
  name: string
  sumup_flag: boolean
  is_enable_sumup: boolean
  uncompleted_subjects: Subject[]
  at_full_count: number

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.exec_date = sheet.exec_date;
    this.grade = sheet.grade;
    this.kind = sheet.kind;
    this.name = sheet.name;
    this.sumup_flag = sheet.sumup_flag;
    this.is_enable_sumup = sheet.is_enable_sumup;
    this.uncompleted_subjects = sheet.uncompleted_subjects;
    this.at_full_count = sheet.at_full_count;
  }
}

export class Subject {
  id: number
  name: string
  curriculum_id: number
  subject_num: string
  sort_key: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_num = sheet.subject_num;
    this.sort_key = sheet.sort_key;
  }
}

export class SumupListCondition{
  sheet_group_key: string = ""
  nendo: string = ""
  month: string = ""
  grade: string = ""
  kind: string = ""
  sumup_flag: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}